// src/Components/payments/PaymentSuccessRouter.jsx
import React from "react";
import { useSearchParams } from "react-router-dom";
import { PaymentSuccess } from "./PaymentResult";
import T2APaymentSuccess from "../../Pages/BlitzPay/t2a/successT2A";

export default function PaymentSuccessRouter() {
  const [searchParams] = useSearchParams();
  const type     = searchParams.get("type");
  const provider = searchParams.get("provider");

  if (type === "t2a_gift" && provider === "stripe") {
    return <T2APaymentSuccess />;
  }

  return <PaymentSuccess />;
}